var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "header",
      { staticClass: "w-100 color-grey1 pos-sticky top-0 bg-grey3 shadow-1" },
      [
        _c("div", { staticClass: "flex-between-center p-15" }, [
          _c("div", { staticClass: "flex-start-center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "searchBar input-group" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchStr,
                    expression: "searchStr",
                  },
                ],
                staticClass: "form-control fsize-12 border-left-0 color-grey2",
                attrs: {
                  type: "text",
                  placeholder: "Trouver un lieu, restaurant ou type de cuisine",
                },
                domProps: { value: _vm.searchStr },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchStr = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action color-grey1" }, [
            _c(
              "div",
              {
                staticClass: "btn-group btn-group-toggle",
                attrs: { "data-toggle": "buttons" },
              },
              [
                _c(
                  "label",
                  { staticClass: "btn", class: { active: _vm.grid } },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.grid,
                          expression: "grid",
                        },
                      ],
                      attrs: { type: "radio", name: "display-mode" },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.grid, true),
                      },
                      on: {
                        change: function ($event) {
                          _vm.grid = true
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          id: "grid",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "26",
                          height: "26",
                          viewBox: "0 0 26 26",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            id: "Path_1581",
                            "data-name": "Path 1581",
                            d: "M24.375,26H1.625A1.627,1.627,0,0,1,0,24.375V1.625A1.627,1.627,0,0,1,1.625,0h22.75A1.627,1.627,0,0,1,26,1.625v22.75A1.627,1.627,0,0,1,24.375,26ZM1.625,1.083a.543.543,0,0,0-.542.542v22.75a.543.543,0,0,0,.542.542h22.75a.543.543,0,0,0,.542-.542V1.625a.543.543,0,0,0-.542-.542Z",
                            fill: "#00a4b9",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Path_1582",
                            "data-name": "Path 1582",
                            d: "M8.042,26a.542.542,0,0,1-.542-.542V.542a.542.542,0,0,1,1.083,0V25.458A.542.542,0,0,1,8.042,26Z",
                            transform: "translate(0.625)",
                            fill: "#00a4b9",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Path_1583",
                            "data-name": "Path 1583",
                            d: "M16.042,26a.542.542,0,0,1-.542-.542V.542a.542.542,0,1,1,1.083,0V25.458A.542.542,0,0,1,16.042,26Z",
                            transform: "translate(1.292)",
                            fill: "#00a4b9",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Path_1584",
                            "data-name": "Path 1584",
                            d: "M25.458,16.583H.542a.542.542,0,1,1,0-1.083H25.458a.542.542,0,0,1,0,1.083Z",
                            transform: "translate(0 1.292)",
                            fill: "#00a4b9",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            id: "Path_1585",
                            "data-name": "Path 1585",
                            d: "M25.458,8.583H.542a.542.542,0,0,1,0-1.083H25.458a.542.542,0,0,1,0,1.083Z",
                            transform: "translate(0 0.625)",
                            fill: "#00a4b9",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "btn", class: { active: _vm.grid } },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.grid,
                          expression: "grid",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "display-mode",
                        checked: "",
                      },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.grid, false),
                      },
                      on: {
                        change: function ($event) {
                          _vm.grid = false
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "26.001",
                          height: "26",
                          viewBox: "0 0 26.001 26",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "placeholder_1_",
                              "data-name": "placeholder (1)",
                              transform: "translate(0.001)",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "Path_811",
                                "data-name": "Path 811",
                                d: "M27.387,18.067a3.033,3.033,0,1,0-3.033-3.033A3.037,3.037,0,0,0,27.387,18.067Zm0-5.2a2.167,2.167,0,1,1-2.167,2.167A2.169,2.169,0,0,1,27.387,12.867Z",
                                transform: "translate(-13.801 -6.8)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_812",
                                "data-name": "Path 812",
                                d: "M20.31,23.728l6.648-9.6a9.469,9.469,0,0,0-.772-11.692,8.309,8.309,0,0,0-11.752,0,9.465,9.465,0,0,0-.782,11.679ZM15.047,3.047a7.443,7.443,0,0,1,10.527,0,8.556,8.556,0,0,1,.682,10.573L20.31,22.205l-5.954-8.6A8.551,8.551,0,0,1,15.047,3.047Z",
                                transform: "translate(-6.8 0)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_813",
                                "data-name": "Path 813",
                                d: "M.433,57.42l-.306.306a.433.433,0,1,0,.613.613l.306-.306a.433.433,0,0,0-.613-.613Z",
                                transform: "translate(-0.001 -32.466)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_814",
                                "data-name": "Path 814",
                                d: "M8.049,52a.433.433,0,1,0,0,.867h.789a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-4.316 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_815",
                                "data-name": "Path 815",
                                d: "M4.578,53.559a.433.433,0,0,0-.613,0l-.558.558a.433.433,0,1,0,.613.613l.558-.558A.433.433,0,0,0,4.578,53.559Z",
                                transform: "translate(-1.86 -30.278)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_816",
                                "data-name": "Path 816",
                                d: "M18.972,52a.433.433,0,1,0,0,.867h.789a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-10.506 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_817",
                                "data-name": "Path 817",
                                d: "M13.51,52a.433.433,0,1,0,0,.867H14.3a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-7.411 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_818",
                                "data-name": "Path 818",
                                d: "M24.433,52a.433.433,0,1,0,0,.867h.433a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-13.601 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_819",
                                "data-name": "Path 819",
                                d: "M.433,49.928A.432.432,0,0,0,.739,49.8l1.68-1.68A.781.781,0,0,1,2.57,48l.084-.045a.394.394,0,0,1,.046-.025l.162-.05a.914.914,0,0,1,.171-.017h6.5a.433.433,0,1,0,0-.867h-6.5a1.788,1.788,0,0,0-.343.034,1.212,1.212,0,0,0-.121.034l-.057.017a1.171,1.171,0,0,0-.141.046,1.25,1.25,0,0,0-.148.075l-.041.023a1.015,1.015,0,0,0-.111.063,1.732,1.732,0,0,0-.265.217l-1.68,1.68a.433.433,0,0,0,.307.74Z",
                                transform: "translate(0 -26.633)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_820",
                                "data-name": "Path 820",
                                d: "M57.726,47.173a.432.432,0,0,0,.306-.127l.306-.306a.433.433,0,0,0-.613-.613l-.306.306a.433.433,0,0,0,.306.74Z",
                                transform: "translate(-32.467 -26.067)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_821",
                                "data-name": "Path 821",
                                d: "M53.544,49.854l-.654.654a.433.433,0,1,0,.613.613l.654-.654a.433.433,0,0,0-.613-.613Z",
                                transform: "translate(-29.9 -28.178)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_822",
                                "data-name": "Path 822",
                                d: "M47.108,52a.433.433,0,0,0,0,.867h.925a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-26.45 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_823",
                                "data-name": "Path 823",
                                d: "M40.7,52a.433.433,0,0,0,0,.867h.925a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-22.82 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_824",
                                "data-name": "Path 824",
                                d: "M35.433,52a.433.433,0,1,0,0,.867h.433a.433.433,0,1,0,0-.867Z",
                                transform: "translate(-19.834 -29.467)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_825",
                                "data-name": "Path 825",
                                d: "M28.66,52.369l-1.68,1.68a.792.792,0,0,1-.15.117l-.081.044a.5.5,0,0,1-.052.027.337.337,0,0,1-.042.013l-.12.036a.839.839,0,0,1-.168.017H6.819l-.657.529a.433.433,0,1,0,.543.675l.42-.338H26.367a1.7,1.7,0,0,0,.338-.034,1.049,1.049,0,0,0,.128-.035l.054-.016a1.185,1.185,0,0,0,.145-.048,1.32,1.32,0,0,0,.146-.074l.043-.023a.951.951,0,0,0,.107-.061,1.718,1.718,0,0,0,.266-.218l1.68-1.68a.433.433,0,0,0-.613-.613Z",
                                transform: "translate(-3.401 -29.604)",
                                fill: "#00a4b9",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                id: "Path_826",
                                "data-name": "Path 826",
                                d: "M39,45.733a.433.433,0,0,0,.433.433h5.275l1.427-1.427a.433.433,0,0,0-.613-.613L44.349,45.3H39.433A.433.433,0,0,0,39,45.733Z",
                                transform: "translate(-22.101 -24.933)",
                                fill: "#00a4b9",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.grid,
            expression: "!grid",
          },
        ],
        staticClass: "displayMapList contentHeight row no-gutters",
      },
      [
        _c("div", { staticClass: "col-xl-4 p-0 h-100" }, [
          _c(
            "div",
            { staticClass: "row no-gutters shops-list overflow-y p-10 h-100" },
            _vm._l(_vm.filteredShops, function (shop) {
              return _c(
                "div",
                { key: shop.ShopId, staticClass: "shop-item col-12 p-10" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "shop-panel radius-5 d-flex",
                      class: { "selected bg-bo-p1": shop == _vm.currentShop },
                      attrs: { id: "shop-" + shop.ShopId },
                      on: {
                        click: function ($event) {
                          return _vm.open(shop.ShopId)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "shop-panel-pic pos-relative radius-5 no-overflow",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "shop-img h-100 pos-relative flex-center-center bg-grey3",
                            },
                            [
                              shop.Image
                                ? _c("img", {
                                    staticClass: "img-fit w-100 h-100",
                                    attrs: {
                                      src: _vm.UrlService.imagePath(
                                        shop.ShopId,
                                        shop.ImageThumb || shop.Image
                                      ),
                                      alt: shop.DefaultName,
                                      width: "260",
                                      height: "160",
                                    },
                                    on: {
                                      error: function ($event) {
                                        $event.target.src =
                                          "dist/assets/no-img.png"
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !shop.Image
                                ? _c("img", {
                                    staticClass: "noPic-logo",
                                    attrs: {
                                      src: "dist/assets/eatself_avatar.svg",
                                      alt: shop.DefaultName,
                                      width: "40",
                                      height: "40",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "shop-panel-details flex-between-start flex-column p-10 w-100 fsize-13",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "shop-panel-details-top d-flex w-100",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "shopLogo radius-circle bg-grey3 border-bo-grey3 flex-center-center text-uppercase text-bold color-grey1 mr-5",
                                },
                                [
                                  shop.Logo
                                    ? _c("img", {
                                        staticClass: "img-circle w-100 h-100",
                                        attrs: {
                                          src: _vm.UrlService.imagePath(
                                            shop.ShopId,
                                            shop.Logo
                                          ),
                                          alt: shop.DefaultName,
                                        },
                                        on: {
                                          error: function ($event) {
                                            $event.target.src =
                                              "dist/assets/no-img.png"
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !shop.Logo
                                    ? _c("div", { staticClass: "noPic" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              shop.DefaultName &&
                                                shop.DefaultName.charAt(0)
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "shopName-shopDescription" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "shopName text-bold text-uppercase",
                                    },
                                    [_vm._v(_vm._s(shop.DefaultName))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "shopDescription color-bo-grey2",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            shop.DefaultDescription
                                              ? _vm.SentensizeString(
                                                  shop.DefaultDescription
                                                )
                                              : "Restaurant"
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "shop-panel-details-bottom flex-between-end w-100",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "shopAddress-shopType w-100",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.setCurrentShop(shop)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "shopAddress pt-10 flex-start-center color-bo-s2",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-eatselfapp_map-pin mr-5 fsize-16 no-line-height",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.getShopAddress(shop))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "shopStatus fsize-10" },
                                [
                                  !_vm.ShopService.isOpen(shop)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "closeStatus flex-start-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-uppercase" },
                                            [_vm._v("Fermé")]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-circle color-ko ml-5 fsize-12 no-line-height",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.ShopService.isOpen(shop)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "openStatus flex-start-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-uppercase" },
                                            [_vm._v("Ouvert")]
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-circle color-ok ml-5 fsize-12 no-line-height",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xl-8 p-0 h-100" }, [
          _c("div", {
            ref: "googleMap",
            staticClass: "google-map contentHeight gm-map",
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.grid,
            expression: "grid",
          },
        ],
        staticClass: "displayGrid contentHeight row no-gutters",
      },
      [
        _c("div", { staticClass: "col-sm-2 p-0 bg-grey3 h-100 hidden" }, [
          _vm._v("FILTERS"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 w-100 h-100 p-0 overflow-y" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "row shops-list m-0 p-10" },
              _vm._l(_vm.filteredShops, function (shop) {
                return _c(
                  "div",
                  {
                    key: shop.ShopId,
                    staticClass:
                      "shop-item col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "shop-panel radius-5",
                        class: { "selected bg-bo-p1": shop == _vm.currentShop },
                        attrs: { id: "shop-" + shop.ShopId },
                        on: {
                          click: function ($event) {
                            return _vm.open(shop.ShopId)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "shop-panel-pic pos-relative radius-5 no-overflow",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "shop-img h-100 pos-relative flex-center-center bg-white",
                              },
                              [
                                shop.Image
                                  ? _c("img", {
                                      staticClass: "img-fit w-100 h-100",
                                      attrs: {
                                        src: _vm.UrlService.imagePath(
                                          shop.ShopId,
                                          shop.ImageThumb || shop.Image
                                        ),
                                        alt: shop.DefaultName,
                                        width: "260",
                                        height: "160",
                                      },
                                      on: {
                                        error: function ($event) {
                                          $event.target.src =
                                            "dist/assets/no-img.png"
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !shop.Image
                                  ? _c("img", {
                                      staticClass: "noPic-logo",
                                      attrs: {
                                        src: "dist/assets/eatself_avatar.svg",
                                        alt: shop.DefaultName,
                                        width: "40",
                                        height: "40",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "shop-img-overlay color-white pos-absolute top-0 w-100 h-100 flex-column flex-between-start p-10",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "shop-img-overlay-top flex-between-start w-100",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "shopLogo radius-circle bg-grey3 border-bo-grey3 flex-center-center text-uppercase text-bold color-grey1 mr-5",
                                      },
                                      [
                                        shop.Logo
                                          ? _c("img", {
                                              staticClass:
                                                "img-circle w-100 h-100",
                                              attrs: {
                                                src: _vm.UrlService.imagePath(
                                                  shop.ShopId,
                                                  shop.Logo
                                                ),
                                                alt: shop.DefaultName,
                                              },
                                              on: {
                                                error: function ($event) {
                                                  $event.target.src =
                                                    "dist/assets/no-img.png"
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !shop.Logo
                                          ? _c(
                                              "div",
                                              { staticClass: "noPic" },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      shop.DefaultName &&
                                                        shop.DefaultName.charAt(
                                                          0
                                                        )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "shopStatus fsize-10" },
                                      [
                                        !_vm.ShopService.isOpen(shop)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "closeStatus flex-start-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-uppercase",
                                                  },
                                                  [_vm._v("Fermé")]
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-circle color-ko ml-5 fsize-12 no-line-height",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.ShopService.isOpen(shop)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "openStatus flex-start-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-uppercase",
                                                  },
                                                  [_vm._v("Ouvert")]
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-circle color-ok ml-5 fsize-12 no-line-height",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "shop-img-overlay-bottom w-100",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "shopName text-bold text-uppercase text-truncate",
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(shop.DefaultName) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "shop-panel-details p-10 w-100 fsize-13",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "shopDescription color-bo-grey2 text-truncate",
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      shop.DefaultDescription
                                        ? _vm.SentensizeString(
                                            shop.DefaultDescription
                                          )
                                        : "Restaurant"
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "shopAddress py-10 flex-start-center color-bo-s2",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "icon-eatselfapp_map-pin mr-5 fsize-16 no-line-height",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.getShopAddress(shop))),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "footer",
      {
        staticClass: "pos-sticky bottom-0 m-0 p-0 bg-bo-s1 color-white",
        staticStyle: { height: "50px" },
      },
      [
        _c("div", { staticClass: "content-footer p-15" }, [
          _c("div", { staticClass: "copy" }, [
            _c(
              "a",
              {
                staticClass: "color-white",
                attrs: { href: "https://www.clyosystems.com" },
              },
              [_vm._v("Caisse Enregisteuse")]
            ),
            _vm._v(
              "\n\t\t\t\t© " +
                _vm._s(_vm.year) +
                " Eatself. Tous droits réservés\n\t\t\t"
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo mr-20" }, [
      _c("img", {
        attrs: {
          alt: "Eatself",
          src: "dist/assets/eatself-sticky_logo@2x.png",
          width: "120",
          height: "40",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend bg-white" }, [
      _c("span", {
        staticClass:
          "fa fa-search border-right-0 input-group-text color-grey2 bg-none",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }